
const __default__ = {
  props: {
    icon: {
      type: String,
      default: undefined
    },
    count: {
      type: [Number, String],
      default: undefined
    },
    text: {
      type: String,
      default: undefined
    },
    color: {
      type: String,
      default: 'var(--brand-700)'
    },
    active: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: String,
      default: undefined
    }
  },
  computed: {
    c_icon_size(){
      return this.iconSize ? this.iconSize : this.small ? '1.2rem' : '2rem'
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "655d7e20-color": (_ctx.color)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__